import { NgModule } from '@angular/core';
import { OktaAuthGuard, OktaCallbackComponent } from '@okta/okta-angular';
import { Router, RouterModule, Routes } from '@angular/router';

import { AccessDeniedComponent } from './auth/components/access-denied/access-denied.component';
import { AccessRequiredGuard } from './auth/guards/access-required.guard';
import { APICGuard } from './auth/guards/apic.guard';
import { LoginComponent } from './auth/components/login/login.component';
import { UnavailableComponent } from './auth/components/unavailable/unavailable.component';
import { UserResolver } from './user/resolvers/user.resolver';

export function onAuthRequired(oktaAuth, injector): void {
  const router: Router = injector.get(Router);

  // Redirect the user to your custom login page
  router.navigate(['/login']);
}

const routes: Routes = [
  {
    path: 'access-denied',
    component: AccessDeniedComponent
  },
  {
    path: 'portal',
    loadChildren: () => import('./portal/portal.module').then(mod => mod.PortalModule),
    canActivate: [
      OktaAuthGuard,
      APICGuard
    ],
    data: {
      onAuthRequired,
    },
    resolve: {
      user: UserResolver,
    }
  },
  {
    path: 'login/callback',
    component: OktaCallbackComponent,
    canActivate: [
      AccessRequiredGuard,
    ]
  },
  {
    path: 'login',
    pathMatch: 'full',
    component: LoginComponent,
  },
  {
    path: 'logout',
    redirectTo: 'login'
  },
  {
    path: 'unavailable',
    pathMatch: 'full',
    component: UnavailableComponent,
  },
  {
    path: '',
    pathMatch: 'full',
    redirectTo: '/portal',
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
    initialNavigation: 'enabled',
    scrollPositionRestoration: 'top'
}),
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
